/**
 * Service for the tenant profile knowledge base (templates, categories, fields).
 */
import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

export const BASE_URL = `${Config.api.tenantSettings.url}api/v1/`;

class TenantProfileService {
  getTemplates() {
    return ApiService.get(`${BASE_URL}tenants/profile-templates`).then((response) => response.data);
  }
  getTemplate(id) {
    return ApiService.get(`${BASE_URL}tenants/profile-templates/${id}`).then((response) => response.data);
  }
  createTemplate(payload) {
    return ApiService.post(`${BASE_URL}tenants/profile-templates`, payload).then((response) => response.data);
  }
  updateTemplate(id, payload) {
    return ApiService.put(`${BASE_URL}tenants/profile-templates/${id}`, payload).then((response) => response.data);
  }
  deleteTemplate(id) {
    return ApiService.delete(`${BASE_URL}tenants/profile-templates/${id}`).then((response) => response.data);
  }
  createCategory(templateId, payload) {
    return ApiService.post(`${BASE_URL}tenants/profile-templates/${templateId}/categories`, payload).then(
      (response) => response.data,
    );
  }
  updateCategory(templateId, categoryId, payload) {
    return ApiService.put(`${BASE_URL}tenants/profile-templates/${templateId}/categories/${categoryId}`, payload).then(
      (response) => response.data,
    );
  }
  deleteCategory(templateId, categoryId) {
    return ApiService.delete(`${BASE_URL}tenants/profile-templates/${templateId}/categories/${categoryId}`).then(
      (response) => response.data,
    );
  }
  createField(templateId, categoryId, payload) {
    return ApiService.post(
      `${BASE_URL}tenants/profile-templates/${templateId}/categories/${categoryId}/fields`,
      payload,
    ).then((response) => response.data);
  }
  updateField(templateId, categoryId, fieldId, payload) {
    return ApiService.put(
      `${BASE_URL}tenants/profile-templates/${templateId}/categories/${categoryId}/fields/${fieldId}`,
      payload,
    ).then((response) => response.data);
  }
  deleteField(templateId, categoryId, fieldId) {
    return ApiService.delete(
      `${BASE_URL}tenants/profile-templates/${templateId}/categories/${categoryId}/fields/${fieldId}`,
    ).then((response) => response.data);
  }
}

export const tenantProfileService = new TenantProfileService();
